export const API_KEY_LENGTH = 32;

export interface ApiKey {
  first4: string | null;
  unencryptedKey?: string;
}
